import React from 'react';
import { scrollTop } from '@share/utils';
import { GetawayWrapper } from '@components';

import './style.scss';

interface IProps {}

export class GetawayPage extends React.Component {
  constructor(props: IProps) {
    super(props);

    scrollTop();
  }

  render(): React.ReactNode {
    return <GetawayWrapper />;
  }
}
